module.exports = "<router-outlet name=\"header\"></router-outlet>\n<router-outlet name=\"sidebar\"></router-outlet>\n<router-outlet></router-outlet>\n<!--<router-outlet name=\"footer\"></router-outlet>-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main